import querySelectorAll from 'utils/DOM/querySelectorAll'
import textContent from 'utils/DOM/textContent'
import isVisible from 'core/DOM/isVisible'

function addFirstCignaRef() {
  let cignaNode = Array.from(querySelectorAll('.plan.cigna')).find(isVisible)
  if (cignaNode) {
    cignaNode = cignaNode.querySelector('.plan__network-provider')
    if (cignaNode) {
      textContent(cignaNode, (cignaNode.innerText += ' †'))
    }
  }
}

export default addFirstCignaRef
